export default {
  'pet-profile:page:title': 'Mein Profil',
  'pet-profile:header:title': '<p>Eine</p> <p>Persönliche</p> <p>Auswahl</p>',
  'pet-profile:display:not-chosen': 'Nicht gewählt',
  'pet-profile:display:breed-not-chosen': 'Rasse: Keine Angabe',
  'pet-profile:display:age-not-chosen': 'Alter: Keine Angabe',
  'pet-profile:display:needs-not-chosen': 'Bedürfnis: Keine Angabe',
  'pet-profile:display:food-type-not-chosen': 'Futtertyp: Keine Angabe',
  'pet-profile:display:your-pet': 'Für Deinen Hund',
  'pet-profile:display:edit': 'Bearbeiten',
  'pet-profile:display:edit-your-pet-profile':
    'Bearbeite dein persönliches Profil',
  'pet-profile:display:edit-your-pet-profile:title:empty':
    'Erstelle ein Profil für deinen Vierbeiner',
  'pet-profile:display:edit-your-pet-profile:title:filled': 'Profil bearbeiten',
  'pet-profile:display:edit-your-pet-profile:subtitle':
    'Für gezielte Produktempfehlungen, die wirklich passen!',
  'pet-profile:display:food-preference': 'Futtermittelpräferenz',
  'pet-profile:cdp:title':
    'Wau! Empfehlungen - abgestimmt auf eure Bedürfnisse',
  'pet-profile:cdp:title:cat': 'Empfehlungen für Deine Katze',
  'pet-profile:no-petprofile-page:title':
    'Individuelle Produktempfehlung in 3, 2, 1 …!',
  'pet-profile:no-petprofile-page:text': `Verrate uns Alter, Rasse und die besonderen Bedürfnisse deines Lieblings und erhalte eine persönliche Produktauswahl von uns. {br}
        {br}
        Du hast bereits bei uns bestellt? Dann logge dich in deinen bestehenden Account ein.`,
  'pet-profile:no-petprofile-page:start': 'Futterempfehlung erstellen',
  'pet-profile:no-petprofile-page:login': 'Jetzt einloggen',
  'pet-profile:header:your-pet': 'Dein Vierbeiner',
  'pet-profile:header:add-profile': 'Weiteres Profil anlegen',
  'pet-profile:placeholder:dog-name': 'Dein Vierbeiner',
  'pet-profile:segmentation-update-sheet:weight-error':
    'Gewicht muss zwischen {min} und {max} kg liegen',
  'pet-profile:segmentation-update-sheet:name:placeholder': 'Name eingeben',
  'pet-profile:guide-change-pet-description':
    'Hier kannst du zwischen deinen Profilen wechseln',
  'pet-profile:guide-edit-description':
    'Für ein besseres Erlebnis – gib deinem Vierbeiner einen Namen!',
  'pet-profile:segmentation-update-sheet:delete-profile:button':
    'Dieses Profil löschen',
  'pet-profile:segmentation-update-sheet:delete-profile:title':
    'Bist du sicher?',
  'pet-profile:segmentation-update-sheet:delete-profile:text:with-pet-name':
    'Bist du sicher, dass du {petName} Profil löschen möchtest? Diese Aktion lässt sich nicht rückgängig machen.',
  'pet-profile:segmentation-update-sheet:delete-profile:text:without-pet-name':
    'Bist du sicher, dass du dein persönliches Profil löschen möchtest? Diese Aktion lässt sich nicht rückgängig machen.',
  'pet-profile:segmentation-update-sheet:delete-profile:confirm': 'Ja, löschen',
  'pet-profile:segmentation-update-sheet:delete-profile:cancel': 'Abbrechen',
  'pet-profile:error:duplicate-name':
    'Du hast bereits ein bestehendes Profil mit diesem Namen.',
  'pet-profile:error:name-required': 'Bitte gib einen Namen ein.',

  'pet-profile:feed-type-selector:title': 'Futterart & Konsistenz',
  'pet-profile:feed-type-selector:wet_food': 'Nassfutter',
  'pet-profile:feed-type-selector:dry_food': 'Trockenfutter',
  'pet-profile:feed-type-selector:snacks': 'Snacks',
  'pet-profile:feed-type-selector:wet_food:sauce': 'Sauce',
  'pet-profile:feed-type-selector:wet_food:pate': 'Pate',
  'pet-profile:feed-type-selector:wet_food:cream': 'Cream',
  'pet-profile:feed-type-selector:wet_food:description:sauce':
    'Saucen Menü, Juicy Filet',
  'pet-profile:feed-type-selector:wet_food:description:pate':
    'Pure Meat, Filet Menü, Meaty Pate',
  'pet-profile:feed-type-selector:wet_food:description:cream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency-title': 'Konsistenz',
  'pet-profile:feed-type-selector:consistency:sauce': 'Saucen',
  'pet-profile:feed-type-selector:consistency:pate': 'Pate',
  'pet-profile:feed-type-selector:consistency:cream': 'Cream',
  'pet-profile:feed-type-selector:consistency:sauce:saucen-menu': 'Saucen Menü',
  'pet-profile:feed-type-selector:consistency:sauce:juicyfilets': 'Juicy Filet',
  'pet-profile:feed-type-selector:consistency:pate:puremeat': 'Pure Meat',
  'pet-profile:feed-type-selector:consistency:pate:filet-menu': 'Filet Menü',
  'pet-profile:feed-type-selector:consistency:pate:meatypate': 'Meaty Pate',
  'pet-profile:feed-type-selector:consistency:cream:silkycream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency:all': 'Alle Konsistenzen',

  'pet-profile:taste-selector:title': 'Bevorzugte Geschmacksrichtung',
  'pet-profile:taste-selector:description':
    'Wähle die Geschmacksrichtung, die deiner Samtpfote am besten schmeckt',
  'pet-profile:no-pet-profile:title:dog': 'Suchst du das Profil deines Hundes?',
  'pet-profile:no-pet-profile:title:cat': 'Suchst du das Profil deiner Katze?',
  'pet-profile:no-pet-profile:title:name': 'Suchst du {name} Profil?',
};
